import { StyledDropdownButton } from "./style";

const DropdownButton = ({
  items,
  buttonText,
  handleItemClicked,
  onButtonClick,
  disabled = false,
}) => {
  const menuProps = {
    items,
    onClick: handleItemClicked,
  };

  return (
    <StyledDropdownButton
      color="primary"
      type="primary"
      menu={menuProps}
      onClick={onButtonClick}
      disabled={disabled}
    >
      {buttonText}
    </StyledDropdownButton>
  );
};

export default DropdownButton;
